require('./angular-cookies');
module.exports = 'ngCookies';



//////////////////
// WEBPACK FOOTER
// ./~/angular-cookies/index.js
// module id = 9
// module chunks = 2